import { END_POINTS } from "../constants/urls";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  status: number;
  data?: any;
  message: string;
};

export const categoryApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategory: builder.query<CommonResponse, { search: string }>({
      query: ({ search }) => ({
        url: `${END_POINTS.category}?search=${search}`,
        method: "GET",
      }),
    }),

    addCategory: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.addCategory,
        method: "POST",
        body,
      }),
    }),

    updateCategory: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.editCategory,
        method: "PATCH",
        body,
      }),
    }),

    deleteCategory: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteCategory}/${id}`,
        method: "DELETE",
      }),
    }),

    changeCategoryStatus: builder.mutation<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.categoryStatus}/${id}`,
        method: "PATCH",
      }),
    }),

    getInternalProcess: builder.query<CommonResponse, { search: string }>({
      query: ({ search }) => ({
        url: `${END_POINTS.getInternalProcess}?search=${search}`,
        method: "GET",
      }),
    }),

    addInternalProcess: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.addInternalProcess,
        method: "POST",
        body,
      }),
    }),

    updateInternalProcess: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.editInternalProcess,
        method: "PATCH",
        body,
      }),
    }),

    deleteInternalProcess: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteInternalProcess}/${id}`,
        method: "DELETE",
      }),
    }),

    changeInternalProcessStatus: builder.mutation<
      CommonResponse,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.InternalProcessStatus}/${id}`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useLazyGetCategoryQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useLazyDeleteCategoryQuery,
  useChangeCategoryStatusMutation,
  useLazyGetInternalProcessQuery,
  useUpdateInternalProcessMutation,
  useAddInternalProcessMutation,
  useChangeInternalProcessStatusMutation,
  useLazyDeleteInternalProcessQuery,
} = categoryApi;
